import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const CountdownTimer = ({ initialTime = 120, onExpire, isActive = true }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    if (!isActive || isExpired) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          setIsExpired(true);
          onExpire && onExpire();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [isActive, isExpired, onExpire]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes?.toString()?.padStart(2, '0')}:${remainingSeconds?.toString()?.padStart(2, '0')}`;
  };

  const formatPersianNumbers = (text) => {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return text?.replace(/\d/g, (digit) => persianDigits?.[parseInt(digit)]);
  };

  const resetTimer = () => {
    setTimeLeft(initialTime);
    setIsExpired(false);
  };

  if (isExpired) {
    return (
      <div className="flex items-center justify-center text-sm text-muted-foreground">
        <Icon name="Clock" size={16} className="ml-2 text-warning" />
        <span>زمان کد منقضی شده است</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center text-sm text-muted-foreground">
      <Icon name="Clock" size={16} className="ml-2" />
      <span>
        زمان باقی‌مانده: {formatPersianNumbers(formatTime(timeLeft))}
      </span>
    </div>
  );
};

export default CountdownTimer;